import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { downloadInBrowser } from 'utils/downloadInBrowser';
import { getSvgViewBox } from 'utils/image/getSvgViewBox';
import { toPngDataUrl } from 'utils/image/toPngDataUrl';
import { createGraphExportFileName } from '../helpers/createGraphExportFileName';
import { createGraphSvg } from './helpers/createGraphSvg';

export const exportToPng: GraphCommandFactory = (cmdContext) => async () => {
  const state = cmdContext.getState();

  const svg = createGraphSvg(state.graph, state.peekingAtHiddenNodes);

  const viewBox = getSvgViewBox(svg);

  const pngDataUrl = await toPngDataUrl(
    `data:image/svg+xml;base64,${btoa(svg)}`,
    {
      backgroundColor: '#fff',
      // Using viewBox because we know it represents desired dimensions while svg itself is responsive
      // consider in case of copypasting
      width: viewBox?.width,
      height: viewBox?.height,
    },
  );

  const base64Png = pngDataUrl.replace(/^data:image\/\w+;base64,/, '');
  const binaryString = atob(base64Png);
  const pngBytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
  downloadInBrowser(`${createGraphExportFileName(state)}.png`, pngBytes);
};
